<template>
  <section v-editable="cms" :class="[name]" :style="mainCssVars">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__grid-image`]"
        :layout="[
          { size: 1, x: 2, width: 10 },
          { size: 3, x: 4, width: 8 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.left"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__left`"
          :layout="[{ size: 0, bound: 510, ratio: [510, 680] }]"
        ></component>
      </grid-item>
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__grid-content`]"
        :layout="[
          { size: 1, x: 2, width: 20 },
          { size: 3, x: 14, width: 8 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.right"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__right`"
          :layout="[{ size: 0, bound: 510, ratio: [510, 510] }]"
        ></component>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-with-image.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-2-column-stats',
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color-left': this.setColor(
          (this.cms.left_color_background || {}).color || 'transparent',
          this.cms.color_gradient
        ),
        '--bg-color-right': this.setColor(
          (this.cms.right_color_background || {}).color || 'transparent',
          this.cms.color_gradient
        ),
        '--text-align-left': this.cms.left_text_align || '',
        '--text-align-right': this.cms.right_text_align || '',
        '--spacing': this.cms.spacing || '30px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::v-deep .m-slide-v2 {
  min-height: initial;
  picture,
  img {
    min-height: initial;
    object-fit: initial;
  }
}

.m-article-2-column-stats {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: transparent;
  padding: 30px 0;
  &__grid {
    align-items: center;
  }
  &__left,
  &__right {
    padding: var(--spacing);
  }

  &__left {
    background-color: var(--bg-color-left);
    text-align: var(--text-align-left);
  }

  &__right {
    background-color: var(--bg-color-right);
    text-align: var(--text-align-right);
  }
}
</style>
